<template>
    <div class="wrap-content customer-section">
        <div class="filter-section row-min-space">
            <div class="row">
                <div class="col-md-12 filter-title-section">
                    <h2>Deeplinks Sent</h2>
                </div>
                <div class="col-md-12 filter-all-customers">
                    <div class="row">
                        <div :class="{'col-md-3':user.kyb,'col-md-4':!user.kyb}">
                            <b-form-group>
                                <b-form-radio-group
                                    v-model="query.status"
                                    :options="filterList"
                                    buttons
                                    button-variant="outline-primary"
                                    @change="apply"
                                ></b-form-radio-group>
                            </b-form-group>
                        </div>
                        <div class="col-md-2" v-if="user.kyb">
                            <b-form-group>
                                <b-form-select
                                        id="input-3"
                                        v-model="query.type"
                                        class="form-control"
                                        :options="
                                                        filterCategoryOptions
                                                    "
                                        required
                                ></b-form-select>
                            </b-form-group>
                        </div>
                        <div class="col-md-2" v-if="user.kyb">
                            <b-form-group>
                                <b-form-select
                                        id="input-3"
                                        v-model="query.profileType"
                                        class="form-control"
                                        :options="
                                                        filterProfileOptions
                                                    "
                                        required
                                ></b-form-select>
                            </b-form-group>
                        </div>
                        <div :class="{'col-md-5':user.kyb,'col-md-8':!user.kyb}">
                            <div class="row">
                                <div class="col-md-6">
                                    <base-search
                                        placeholder="Search"
                                        @keyword="getKeyword"
                                    ></base-search>
                                </div>
                                <div
                                    :class="{
                                        'col-md-3': hasScopes(
                                            'export-customer-profile'
                                        ),
                                        'col-md-6': !hasScopes(
                                            'export-customer-profile'
                                        ),
                                    }"
                                >
                                    <b-form-group>
                                        <button
                                            class="btn btn-primary"
                                            type="submit"
                                            :class="
                                                loading && showPageLoader
                                                    ? 'disabled'
                                                    : ''
                                            "
                                            @click="apply"
                                        >
                                            <span class="btn-text">Apply</span>
                                            <span class="loader"></span>
                                        </button>
                                    </b-form-group>
                                </div>
                                <div
                                    v-if="hasScopes('export-customer-profile')"
                                    class="col-md-3 text-right export-file-btn"
                                >
                                    <b-form-group>
                                        <b-button
                                            type="button"
                                            variant="secondary"
                                            class="secondary-add-btn"
                                            @click="exportRecords"
                                        >
                                            <span class="btn-text">EXPORT</span>
                                        </b-button>
                                    </b-form-group>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div
            :class="[
                'table-section',
                'table-min-width',
                {
                    'overflow-hidden': !data.length && !showPageLoader,
                },
            ]"
        >
            <b-table
                :items="data"
                :fields="fields"
                no-local-sorting
                @sort-changed="sortingChanged"
            >
            <!------------------Image placeholder added by SAIF------------------>
            <template slot="pictureURL" slot-scope="data">
                    <div class="profile-area">
                        <router-link :to="{
                            name: 'temp-customer-information',
                            params: {
                                id: data.item._id,
                            },
                        }">
                            <div v-if="data.item.pictureURL!=null && data.item.pictureURL!='customers/no-preview.png'" 
                                class="profile-pic"
                                v-authenticated-image="data.item.pictureURL"
                                alt="Profile Image">
                                <!--------src value should be added to show the image-->
                            </div>
                            <div v-else class="profile-pic"
                            v-authenticated-image="'users/blank-profile-pic.png'"
                            alt="Profile Image" >
                            </div>
                            
                        </router-link>
                    </div>
                </template>
                <!------------------Image placeholder added by SAIF------------------>

                <template slot="idenfoId" slot-scope="data">
                    <div class="customer-link">
                        <router-link :to="{
                            name: data.item.customerId ? getRouteName(data.item) :'temp-customer-information',
                            params: {
                                id: data.item.customerId ? data.item.customerId :data.item._id,
                            },
                        }">
                            {{ data.item.idenfoId }}
                        </router-link>
                    </div>
                </template>

                <template slot="fullName" slot-scope="data">
                    <div class="action-flex">
                        <router-link
                            :to="{
                                name: data.item.customerId ? getRouteName(data.item) :'temp-customer-information',
                                params: {
                                    id: data.item.customerId ? data.item.customerId :data.item._id,
                                },
                            }"
                        >
                            <span>
                                {{ data.item.fullName | titleCase }}
                            </span>
                        </router-link>
                    </div>
                </template>

                <!-- Join Date -->
                <template slot="createdAt" slot-scope="data">
                    {{ data.item.createdAt | moment('MMM D, YYYY h:mm a') }}
                </template>

                <template slot="status" slot-scope="data">
                    <base-status :status-type="data.item.status"></base-status>
                </template>

                <template slot="action" slot-scope="data">
                    <div class="action-review">
                        <base-action
                            icon="icon-eye-view"
                            label="View Profile"
                            @click="
                                $router.push({
                                    name: data.item.customerId ? getRouteName(data.item) :'temp-customer-information',
                                    params: {
                                        id: data.item.customerId ? data.item.customerId :data.item._id,
                                    },
                                })
                            "
                        ></base-action>
                    </div>
                    <div v-if="data.item.status != 'Submitted'" class="mt-3 action-review">
                        <base-action
                            icon="icon-edit"
                            label="Resend Invite"
                            @click="
                                showConfirmationPopup(data.item)
                            "
                        ></base-action>
                    </div>
                </template>
            </b-table>
            <!-- When data is loading -->
            <base-table-spinner
                v-if="!data.length && showPageLoader"
            ></base-table-spinner>
            <!-- When record not found -->
            <base-no-record-found
                v-if="!data.length && !showPageLoader"
            ></base-no-record-found>
        </div>

        <base-records
            path="users/temp-applications"
            :query="query"
            :reset="reset"
            :show-pagination="true"
        ></base-records>

        <export-process-popup
            :id="id"
            title="Export Customer's Data"
            :url="cancelUrl"
        ></export-process-popup>

        <generic-confirm-popup 
        title="Resend Onboard Invite"
        description="Are you sure, You want to Resend Onboarding Email?"
        :onConfirm="resendInvite" >
        </generic-confirm-popup>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import exportProcessPopup from '@/components/popups/ExportProcessPopup.vue'
import GenericConfirmPopup from '../../components/popups/GenericConfirmPopup.vue'
import request from '@/utils/request'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {
        exportProcessPopup,
        GenericConfirmPopup,
    }, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            APP_URL: process.env.VUE_APP_API_URL,
            fields: {
                pictureURL: {
                    label: '',
                    tdClass: 'profile-absolute',
                    tdAttr: {
                        dataname: '',
                    },
                },
                idenfoId: {
                    label: 'CUSTOMER',
                    sortable: true,
                    tdAttr: {
                        dataname: 'Customer',
                    },
                },
                fullName: {
                    label: 'NAME',
                    sortable: true,
                    tdAttr: {
                        dataname: 'Full Name',
                    },
                    tdClass: 'email-truncate',
                },
                email: {
                    key: 'email',
                    label: 'EMAIL',
                    sortable: true,
                    tdAttr: {
                        dataname: 'email',
                    },
                },
                // countryOfResidence: {
                //     key: 'basicInfo.countryOfResidence',
                //     label: 'RESIDENCE',
                //     sortable: true,
                //     tdAttr: {
                //         dataname: 'countryOfResidence',
                //     },
                // },
                type: {
                    key: 'type',
                    label: 'Category',
                    sortable: true,
                    formatter: (value) => {
                        if (value ) {
                            return _.startCase(value)
                        }
                        else if (value=='' || !value) {
                            return 'Individual'
                        }
                    },
                },
                createdAt: {
                    label: 'REGISTRATION DATE',
                    sortable: true,
                    tdAttr: {
                        dataname: 'createdAt',
                    },
                },
                userName: {
                    label: 'Onboarded By',
                    sortable: true,
                    tdAttr: {
                        dataname: 'userName',
                    },
                    // tdClass: 'email-truncate',
                },
                status: {
                    label: 'STATUS',
                    sortable: true,
                    tdClass: 'text-center status-absolute-pos',
                    thClass: 'text-center',
                    tdAttr: {
                        dataname: 'status',
                    },
                },
                action: {
                    label: 'Actions',
                    tdClass: 'w-150px',
                    tdAttr: {
                        dataname: 'Actions',
                    },
                },
            },
            filterList: [
                { text: 'All', value: null },
                { text: 'Pending', value: 'pending' },
                { text: 'Expired', value: 'expired' },
                { text: 'Submitted', value: 'Submitted' },
            ],
            filterCategoryOptions: [
                { text: 'All Category', value: null },
                { text: 'Individual', value: 'individual' },
                { text: 'Company', value: 'company' },
            ],
            filterProfileOptions: [
                { text: 'All Relations', value: null },
                { text: 'Citizen', value: 'Citizen' },
                { text: 'Resident Expat', value: 'Resident Expat' },
                { text: 'Non-resident (tourist)', value: 'Non-resident (tourist)' },
                { text: 'Customer', value: 'Customer' },
                { text: 'Supplier', value: 'Supplier' },
                { text: 'Third Party', value: 'Third Party' },
            ],
            query: {
                startAt: 1,
                keyword: '',
                perPage: 10,
                status: null,
                sortBy: 'idenfoId',
                sortOrder: 'desc',
                type:null,
                profileType:null
            },
            reset: new Date().getTime(),
            id: null,
            cancelUrl: 'customers/cancel-export',
            selectedTempCustomer: null,
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters([
            'data',
            'showPageLoader',
            'loading',
            'dataSegmentId',
            'hasScopes',
            'user'
        ]),
    }, // End of Component > computed
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {}, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        localStorage.setItem('goBackUrl', this.$route.name)
        let queryData = JSON.parse(localStorage.getItem('queryData'))
        if (queryData) {
            Object.assign(this.query, queryData)
            localStorage.removeItem('queryData')
        }
    }, // End of Component > watch

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        getRouteName(item) {
            let routeName =
                item.type == 'company'
                    ? 'company-information'
                    : 'customer-information'
            if (this.user.accountType == 'lite') {
                routeName =
                    item.type == 'company'
                        ? 'screening-company'
                        : 'screening-customer'
            }
            return routeName
        },
        /**
         *
         * @return {void}
         */
        getKeyword(val) {
            this.query.keyword = val
        }, // End of getKeyword() method

        /**
         *
         * @return {void}
         */
        apply() {
            this.$store.commit('setLoading', true)
            this.reset = new Date().getTime()
        }, // End of apply() method

        /**
         *
         * @return {void}
         */
        selectedRecord(record) {
            this.$store.commit('setItem', record)
        }, // End of selectedRecord() method

        /**
         *
         * @return {void}
         */
        sortingChanged(ctx) {
            // ctx.sortBy   ==> Field key for sorting by (or null for no sorting)
            this.query.sortBy = ctx.sortBy

            // ctx.sortDesc ==> true if sorting descending, false otherwise
            this.query.sortOrder = ctx.sortDesc ? 'desc' : 'asc'

            this.apply()
            this.$store.commit('setLoading', false)
        }, // End of sortingChanged() method

        /**
         *
         * @return {void}
         */
        async exportRecords() {
            try {
                this.query.dataSegmentId = this.dataSegmentId

                let { data } = await request.post('customers/export', null, {
                    params: this.query,
                })
                console.log(data)
                this.id = data.data.id
                this.$bvModal.show('export-process-popup')
                this.$toasted.show(data.message, {
                    type: 'success',
                })
            } catch (error) {
                console.log(error, 'error')
            }
        }, // End of exportRecords() method

        showConfirmationPopup(tempCustomer){
            this.selectedTempCustomer = tempCustomer;
            this.$bvModal.show('confirmation-generic-popup');
        },
        async resendInvite(){
            try{
                this.$store.commit('setLoading',true)

                let {data} = await request.post('customers/resend-onboarding-invite', {
                    tempCustomerId: this.selectedTempCustomer._id
                })
                this.$store.commit('setSuccess', data.message)
                this.data = this.data.map(el=>{
                    if(el._id == this.selectedTempCustomer._id){
                        el.status = 'pending'
                    }
                    return el;
                })
                this.$store.commit('setLoading',false)
                
                this.selectedTempCustomer = null;

            }catch(error){
                console.log(error)
                this.$store.commit('setError', errors)
                this.$store.commit('setLoading',false)

                this.selectedTempCustomer = null;
            }

        }
    }, // End of Component > mounted
} // End of export default
</script>
